// Generic submit interceptor registry for dynamic forms.
// An interceptor is an async function (payload, initialValues) => payload | null.
// Returning null cancels the submission; returning a (possibly mutated) payload continues the chain.

const interceptors = new Set();

export const registerSubmitInterceptor = interceptor => {
  interceptors.add(interceptor);
  return () => interceptors.delete(interceptor);
};

export const runSubmitInterceptors = async (payload, initialValues) => {
  let result = payload;
  const registered = Array.from(interceptors);
  for (let i = 0; i < registered.length; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    result = await registered[i](result, initialValues);
    if (result === null) {
      return null;
    }
  }
  return result;
};
